module.exports = __webpack_public_path__ + "static/img/hx7.8a321e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hx7.png
// module id = C/Al
// module chunks = 1